export var LabelPosition; // Needed for the validation step.

(function (LabelPosition) {
  LabelPosition["Top"] = "top";
  LabelPosition["Leading"] = "leading";
  LabelPosition["Trailing"] = "trailing";
})(LabelPosition || (LabelPosition = {}));